import { PropsWithChildren, createContext, useContext } from 'react';

type ResourceContextValue = {
  data: unknown;
  canEdit: boolean;
};

const ResourceContext = createContext<ResourceContextValue | undefined>(
  undefined,
);

export type Resource<T> = {
  data: T;
  canEdit: boolean;
};

export type ResourceProviderProps = {
  value: ResourceContextValue;
};

export const ResourceProvider = ({
  value,
  children,
}: PropsWithChildren<ResourceProviderProps>) => (
  <ResourceContext.Provider value={value}>{children}</ResourceContext.Provider>
);

export function useResource<T>(): Resource<T> {
  const context = useContext(ResourceContext);
  if (context === undefined) {
    throw new Error('useResource must be used within a ResourceProvider');
  }

  return { data: context.data as T, canEdit: context.canEdit };
}

export function useOptionalResource<T>(): Resource<T> | undefined {
  const context = useContext(ResourceContext);
  if (context === undefined) {
    return undefined;
  }

  return { data: context.data as T, canEdit: context.canEdit };
}
